export default "__VITE_ASSET__DviJpasO__"